import {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Checkbox,
  createStyles,
  Dialog,
  DialogContent,
  Divider,
  makeStyles,
  TextField,
  Theme,
  withStyles
} from '@material-ui/core';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import {useDispatch, useSelector} from "react-redux";
import {IProject} from "../../../store/reducers/creator/creatorDashboard";
import clsx from "clsx";
import {createProject} from "../../../store/actions/creator/creatorDashboard";
import {experiencesReload} from '../../../store/actions/experience/experience';
import {Loading} from '../commonLoadings';
import {
  addProjectToExperience,
  getExperiences,
  getProjectExperiences,
  removeExperienceFromProject
} from "../../../store/actions"

const styles = (theme: Theme) =>
  createStyles({
    root: {
      margin: 0,
      padding: theme.spacing(2),
      paddingTop: 26
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      background: 'transparent!important'
    },
    header: {
      color: '#212D40',
      fontFamily: 'Spartan-bold',
      fontSize: 24,
      paddingLeft: 17,
      paddingBottom: 7,
      display: 'flex',
      alignItems: 'center'
    }
  });

const useStyles = makeStyles(() => ({
  root: {},
  paper: {
    maxWidth: 500,
    borderRadius: '24px!important'
  },
  btn: {
    width: 'auto',
    height: 37,
    webkitAppearance: 'none',
    borderRadius: 6,
    background: '#0179EE',
    color: '#FFFFFF',
    textTransform: 'none',
    fontSize: 14,
    fontFamily: 'roboto-regular',
    '&:hover': {
      background: '#0f9fef'
    },

  },
  label: {
    "&$focusedLabel": {
      fontSize: 12,
      fontFamily: 'roboto-bold',
      color: "#606B76"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {},
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#697683',
    "&$error:after": {
      borderBottomColor: "#017AEF"
    },
    "&:after": {
      borderBottom: `3px solid #017AEF`
    }
  },
  error: {},
  projectSection: {
    border: '1px solid #B2B9C0',
    borderRadius: 8,
    padding: 20,
    margin: 32,
    height: 250,
    overflowY: 'scroll'
  },
  projectRow: {
    marginLeft: -8,
    display: 'flex',
    alignItems: 'center',
    height: 35,
    fontSize: 14,
    fontFamily: 'roboto-bold',
    color: '#697683',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  },
  icon: {
    borderRadius: 3,
    width: 18,
    height: 18,
    backgroundColor: '#f5f8fa',
    backgroundImage: "url(\"/assets/icons/dashboard/uncheckbox.svg\")",
  },
  checkedIcon: {
    '&:before': {
      display: 'block',
      width: 21,
      height: 18,
      backgroundImage: "url(\"/assets/icons/dashboard/checkbox.svg\")",
      content: '""',
    },
  },
  plusIconBtn: {
    width: 37,
    height: 37,
    background: '#E5E5E5'
  },
  removeProjectBtn: {
    backgroundColor: '#ED564A',
    borderRadius: 6,
    fontSize: 14,
    color: 'white',
    boxShadow: 'none',
    textTransform: 'none',
    '&:hover': {
      backgroundColor: '#ED4F59'
    }
 },
}));

const DialogTitle = withStyles(styles)((props: any) => {
  const {children, classes, onClose, ...other} = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <div className={classes.header}>
        {children}
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <img src={'/assets/icons/creatordashboard/project-modal-close.svg'} alt={'img'}/>
          </IconButton>
        ) : null}
      </div>
    </MuiDialogTitle>
  );
});

AddToProjectModal.propTypes = {
  onClose: PropTypes.func,
  onAdded: PropTypes.func,
  open: PropTypes.bool.isRequired,
  selected: PropTypes.any,
  type: PropTypes.any,
  experienceData: PropTypes.object
};

AddToProjectModal.defaultProps = {
  onClose: () => {
  }
};

function AddToProjectModal({open, onClose, onAdded, selected, type, experienceData }: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const {projects, loading} = useSelector((state: any) => state.creatorDashboard);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const [projectName, setProjectName] = useState('');
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const [checkedProjects, setCheckedProjects] = useState<any[]>([]);
  const { sessions } = useSelector((state: any) => state.experience);
  const [isAllowSave, setIsAllowSave] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      const project_id: any = localStorage.getItem('projectId');
      if(project_id && parseFloat(project_id) !== -1){
        if(!checkedProjects.includes(parseFloat(project_id))){
          setCheckedProjects([...checkedProjects, parseFloat(project_id)])
        }
      }
    }, 100);
  }, []);

  useEffect(() => {
    if(experienceData && experienceData.project_folders && experienceData.project_folders.length > 0){
      setCheckedProjects(experienceData.project_folders)
    }
    setProjectName('');
  }, [open]);
  useEffect(() => {
    if(experienceData){
      const res =  arr_diff()
      if(res.length > 0){
        setIsAllowSave(true)
      }else{
        setIsAllowSave(false)
      }
    }
  }, [checkedProjects]);

  const onAddExperienceToProject = async () => {
    let sessionCodes:any = [];
    if (experienceData) {
      sessionCodes = [experienceData.session_code];
    } else {
      sessionCodes = new Set(selected.map((item: any) => item.session_code));
    }
    const request = {
      session_code: [...sessionCodes],
      project_id: checkedProjects.map(String)
    };
    await dispatch(experiencesReload());

    if (type === "isAdd" || type === "dropMenu") {
      await dispatch(addProjectToExperience(apolloClient.client, request, () => {
        setTimeout(() => {
          if (loginUserData.user_id) {
            const exprequ = {
              user_id: loginUserData.user_id,
              page_no: 1,
              size: sessions.length
            };
            dispatch(getExperiences(apolloClient.client, exprequ, null))      
          }
      
          const projectId: any = localStorage.getItem("projectId");
          if((projectId) && parseFloat(projectId) != -1){
            const proreq = {
              project_id: parseFloat(projectId),
            };
            dispatch(getProjectExperiences(apolloClient.client, proreq, null));
          }
        }, 3000)          
      }));
    } else {
      await dispatch(removeExperienceFromProject(apolloClient.client, request, () => {
        setTimeout(() => {
          if (loginUserData.user_id) {
            const exprequ = {
              user_id: loginUserData.user_id,
              page_no: 1,
              size: sessions.length
            };
            dispatch(getExperiences(apolloClient.client, exprequ, null))      
          }
      
          const projectId: any = localStorage.getItem("projectId");
          if((projectId) && parseFloat(projectId) != -1){
            const proreq = {
              project_id: parseFloat(projectId),
            };
            dispatch(getProjectExperiences(apolloClient.client, proreq, null));
          }
        }, 3000)          
      }));
      // await dispatch(removeExperienceFromProject(apolloClient.client, request, null));
    }
    !loading && addedToProject();
  };
  const removeFromProject = async () => {
    let sessionCodes:any = [];
    if (experienceData) {
      sessionCodes = [experienceData.session_code];
    } else {
      sessionCodes = new Set(selected.map((item: any) => item.session_code));
    }
    const request = {
      session_code: [...sessionCodes],
      project_id: checkedProjects.map(String)
    };
    
    await dispatch(experiencesReload());

    await dispatch(removeExperienceFromProject(apolloClient.client, request, () => {
      setTimeout(() => {
        if (loginUserData.user_id) {
          const exprequ = {
            user_id: loginUserData.user_id,
            page_no: 1,
            size: sessions.length
          };
          dispatch(getExperiences(apolloClient.client, exprequ, null))      
        }
    
        const projectId: any = localStorage.getItem("projectId");
        if((projectId) && parseFloat(projectId) != -1){
          const proreq = {
            project_id: parseFloat(projectId),
          };
          dispatch(getProjectExperiences(apolloClient.client, proreq, null));
        }
      }, 3000)          
    }));
    !loading && closeProjectModal();
  };

  const validateProjectName = (name: string) => {
    return name.length > 1
  };

  const onChangeProjectName = (event: any) => {
    setProjectName(event.target.value);
  };

  const onCheckChange = (e: number) => {
    if (!checkedProjects.includes(e)) {
      setCheckedProjects([...checkedProjects,e])
    } else {
      const array = checkedProjects.filter(function(value){ 
        return value !== e;
      });
      setCheckedProjects(array)
    }
    
  }

  const arr_diff = () => {
    const a1 = checkedProjects
    const a2 = experienceData.project_folders ? experienceData.project_folders : [];
    const a = [], diff = [];
    for (let i = 0; i < a1.length; i++) {
        a[a1[i]] = true;
    }
    for (let i = 0; i < a2.length; i++) {
        if (a[a2[i]]) {
            delete a[a2[i]];
        } else {
            a[a2[i]] = true;
        }
    }
    for (const k in a) {
        diff.push(k);
    }
    return diff;
  }

  const onAddProject = () => {
    if (validateProjectName(projectName)) {
      const request = {
        cascadedProjectOrder: projects.length,
        cascadedProjectId: 0,
        projectOwnerId: Number(loginUserData.user_id),
        departmentId: 0,
        iconStimulusId: 0,
        backgroundStimulusId: 0,
        tagCloud: {},
        projectDescription: "",
        projectName,
        projectAlias: ""
      };
		dispatch(createProject(apolloClient.client, request, (project: any) => {
			if (project && project.projectId) {
				setCheckedProjects([...checkedProjects, parseFloat(project.projectId)])
			}
		}));
      setProjectName('')
    }
  };

  // close project modal
  const closeProjectModal = () => {
    onClose();
    setCheckedProjects([]);
    setIsAllowSave(false)
  };

  const addedToProject = () => {
    onAdded();
    setCheckedProjects([]);
    setIsAllowSave(false)
  };

  return (
    <Dialog
      disableEscapeKeyDown
      fullWidth={true}
      maxWidth={'sm'}
      scroll='paper'
      open={open}
      classes={{
        root: classes.root,
        paper: classes.paper
      }}
    >
      <DialogTitle onClose={closeProjectModal}>
        {type ==="isAdd" &&
          "Add to Project"
        }
        
        {type ==="isRemove" &&
          "Remove from project"
        }
        {experienceData &&  type ==="dropMenu" &&
          "Add to / Remove from Project"
        }
      </DialogTitle>
      <Divider/>
      <DialogContent className={classes.projectSection}>
        <Box>
          {projects.length > 0 && projects.map((project: IProject, index: number) => (
            <div className={classes.projectRow} key={index}>
              <Checkbox
                checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)}/>}
                icon={<span className={classes.icon}/>}
                color="primary"
                checked={checkedProjects.includes(project.projectId) ? true : false}
                onChange={()=>onCheckChange(project.projectId)}
              />
              <img src={`/assets/icons/creatordashboard/folder-icon.svg`} alt={'img'}/>
              &nbsp;&nbsp;
              {project && project.projectName}
            </div>
          ))}
        </Box>
      </DialogContent>
        <Box mr={4} ml={4} mt={-1} display='flex' justifyContent='center' alignItems="center">
          <TextField
            value={projectName}
            InputLabelProps={{
              classes: {
                root: classes.label,
                focused: classes.focusedLabel,
                error: classes.erroredLabel
              },
            }}
            InputProps={{
              classes: {
                root: classes.underline,
                error: classes.error
              }
            }}
            fullWidth
            variant="outlined"
            size="small"
            id="project_name"
            placeholder="Add a new Project"
            name="project_name"
            onChange={onChangeProjectName}
          />
          &nbsp;&nbsp;&nbsp;
          <Button
            className={classes.plusIconBtn}
            onClick={onAddProject}
            disabled={!validateProjectName(projectName)}
            style={!validateProjectName(projectName) ? {background: '#F0F0F0'} : {}}
          >
            <img src={`/assets/icons/creatordashboard/plus-icon.svg`} alt={'img'}/>
          </Button>
        </Box>
      <Box mt={6} mb={3} mr={4} display='flex' justifyContent='flex-end'>
        {!experienceData && checkedProjects.length > 0 && <Button
          className={classes.btn}
          onClick={onAddExperienceToProject}
        >
          {loading? <Loading style={{ width: 60, height: 30, marginTop: -20 }} />: type ==="isAdd" ? 'Add to Project':'Remove from project'}
        </Button>}
        {experienceData && isAllowSave && <Button
          className={classes.btn}
          onClick={onAddExperienceToProject}
        >
          {loading? <Loading style={{ width: 60, height: 30, marginTop: -20 }} />: 'Save'}
        </Button>}
        {experienceData && checkedProjects.length > 0 && <Button
          style={{marginLeft:'5px'}}
          className={classes.removeProjectBtn}
          onClick={removeFromProject}
        >
          {loading? <Loading style={{ width: 60, height: 30, marginTop: -20 }} />: 'Remove'}
        </Button>}
      </Box>
    </Dialog>
  );
}

export default AddToProjectModal;
